import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

export default function OurClients() {

  const clients = [
    {
      id: 1,
      name: "JK PAPER",
      logo: "https://res.cloudinary.com/dirqmm0ky/image/upload/v1773071263/JK-Paper_tqpar7.jpg",
    },
    {
      id: 2,
      name: "Britannia",
      logo: "https://res.cloudinary.com/dirqmm0ky/image/upload/v1773071373/jtqg6gw9iuv54ac4z9ec.jpg",
    },
    {
      id: 3,
      name: "Amul",
      logo: "https://res.cloudinary.com/dirqmm0ky/image/upload/v1773071263/amul_eqago7.jpg",
    },
    {
      id: 4,
      name: "Reliance",
      logo: "https://res.cloudinary.com/dirqmm0ky/image/upload/v1773071263/reliance_um9mvb.jpg",
    },
    {
      id: 5,
      name: "Indian Oil",
      logo: "https://res.cloudinary.com/dirqmm0ky/image/upload/v1773071263/oicl_fxlfze.jpg",
    },
    {
      id: 6,
      name: "NAYARA",
      logo: "https://res.cloudinary.com/dirqmm0ky/image/upload/v1773071263/nayara_oykoph.jpg",
    },
  ];

  return (
    <section className="py-16">
      <div className="max-w-7xl mx-auto px-6">

        {/* SECTION HEADING */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary">
            Our Clients
          </h2>
          <p className="mt-4 text-gray-600 font-body max-w-2xl mx-auto">
            Trusted by leading industries across Ahmedabad and Gujarat for
            reliable water and wastewater treatment solutions.
          </p>
        </div>

        {/* CLIENTS SWIPER */}
        <Swiper
          modules={[Autoplay]}
          autoplay={{ delay: 2500, disableOnInteraction: false }}
          loop
          spaceBetween={30}
          breakpoints={{
            0: { slidesPerView: 2 },
            640: { slidesPerView: 3 },
            768: { slidesPerView: 4 },
            1024: { slidesPerView: 5 },
          }}
        >
          {clients.map((client) => (
            <SwiperSlide key={client.id}>
              <div className="flex items-center justify-center h-28 bg-white rounded-xl shadow-sm hover:shadow-lg transition group cursor-pointer">
                <img
                  src={client.logo}
                  alt={client.name}
                  className="h-[140px] w-[140px] object-contain transition-all duration-300 group-hover:scale-105"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

      </div>
    </section>
  );
}